export default {
      id: "LWS-4px-usage",
      viewBox: "0 0 60 4",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-4px",
      toString: function () {
        return this.url;
      }
    }